<template>
    <div class="login-inputs">
        <div class="headlin-text" style="padding-bottom: 4%;">Sign in</div>
        <div class="input-area">
            <div class="input-field-area">
                <div>Username or email</div>
                <input class="input-filed" type="text" placeholder="eg. myemail@myemail.com" v-model="email" v-on:keyup.enter="makeRequest">
            </div>
            <div class="input-field-area">
                <div>Password</div>
                <input class="input-filed" type="password" v-model="password" v-on:keyup.enter="makeRequest">
            </div>
            <button @click="forgotPassword" style="background: transparent; border: 0px; padding-top: 0.5%; padding-right: 8%; margin-right: 0%; padding-left: 0;"><b style="cursor: pointer;">Forgot Password ?</b></button>
            <div style="padding-top: 3em;">
                <router-link to="/signupdriver" style="text-decoration: none; font-weight: bold; color: #191919;">Sign up as Driver</router-link>
                <span style="padding-left: 2%; padding-right:2%">or</span>
                <router-link to="/signupadvertiser" style="text-decoration: none; font-weight: bold; color: #191919;">Sign up as Advertiser</router-link>
            </div>
        </div>
        <div style="padding-top: 3%">
          <vue-recaptcha :sitekey='config.googleRecaptcheSiteKey' v-if="!isDebug()">
            <button class="adway-btn-class" @click="makeRequest">
              <clip-loader :loading="loginSpinner" :color="'#fff'"/>
              <span v-if="!loginSpinner" class="btn__text__bold">Login</span>
            </button>
          </vue-recaptcha>
          <button class="adway-btn-class" @click="makeRequest" v-if="isDebug()">
            <clip-loader :loading="loginSpinner" :color="'#fff'"/>
            <span v-if="!loginSpinner" class="btn__text__bold">Login</span>
          </button>
        </div>
    </div>
</template>

<script>
import store from '@store'
import toast from '@utils/toast'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import Config from '@utils/Config.js'
import geoLocationService from '@/services/geoLocation'

export default {
  name: 'LoginViewPage1',
  data: function () {
    return {
      email: '',
      password: '',
      loginSpinner: false,
      config: Config
    }
  },
  components: {
    ClipLoader
  },
  methods: {
    validateInputFileds () {
      if (this.email === '' || this.password === '') {
        return false
      } else {
        return true
      }
    },
    async makeRequest() {
      if (this.validateInputFileds()) {
        this.loginSpinner = true
        const url = '/user/login'

        const currentLocationPosition = await geoLocationService.getCurrentLocation()

        const body = {
          user: this.email.trim(),
          API_KEY: this.config.api_key,
          data: {
            secret: this.password,
            local_time: this.$moment(new Date()).format()
          }
        }

        if (currentLocationPosition) {
          body.data.lat = currentLocationPosition.coords.latitude
          body.data.lon = currentLocationPosition.coords.longitude
        }

        this.request(url, 'POST', body).then((response) => {
          if (response.code === 0) {
            this.handleLoginResponse(response)
          } else {
            toast.errorMessage(response.message)
            this.loginSpinner = false
          }
        }).catch((err) => {
          this.loginSpinner = false
        })
      } else {
        var message = ''
        if (this.email === '') {
          message += 'Invalid email address\n'
        }
        if (this.password === '') {
          message += 'No password entered\n'
        }
        toast.errorMessage(message)
      }
    },
    handleLoginResponse (response) {
      if (response.result === 'failure') {
        toast.custom(response.message, "error")
        this.loginSpinner = false
      } else {
        store.commit('setToken', response.data[0])
        store.commit('setDriver', response.data[0].driver)
        this.getProfile(response.data[0].token)
      }
    },
    getProfile (token) {
      var self = this;

      this.request('/get/profile', 'POST', { user: this.email.trim() }).then((response) => {
        this.loginSpinner = false
        if (response.code === 0) {
          store.commit('setUser', response.data[0])
          setTimeout(()=>{
            toast.successMessage('Processing sign in')
            if(response.data[0].role === 'driver') {
              self.$router.push('/driver/account')
            } else {
              if (response.data[0].role === 'manager') {
                self.$router.push('/advertiser/dashboard')
              } else {
                self.$router.push('/' + response.data[0].role + '/dashboard')
              }
            }
          }, 300)
        } else {
          toast.custom(response.message, "error")
        }
      }).catch((error) => {
        this.loginSpinner = false
      })
    },
    forgotPassword () {
      this.$emit('forgotPassword')
    }
  }
}
</script>
